import {
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
} from '@dixa/lib-shared-habla';
import { Satisfaction } from 'lib-shared-legacy-types';

import { languages } from 'app/utils/supportedLanguages';

import styles from './surveyLanguagesDropdown.module.scss';

type SurveyLanguageDropdownProps = {
  handleGoToLanguage: (lang: string) => void;
  languageSettings: Satisfaction.CsatSettings[];
};
export const SurveyLanguageDropdown = (
  props: SurveyLanguageDropdownProps,
): JSX.Element => {
  const availableLanguages = languages.filter(
    ({ code }) =>
      props.languageSettings.filter((settings) => {
        return settings.language === code;
      }).length === 0,
  );

  return (
    <DropdownButton
      noArrow
      fixed
      icon="plus"
      buttonProps={{ variant: 'secondary' }}
      dropdownProps={{ className: styles.languagesDropdown }}
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ toggleDropdown }) => (
            <ButtonList>
              {availableLanguages.map((language) => {
                return (
                  <ButtonList.Item
                    key={language.code}
                    onClick={() => props.handleGoToLanguage(language.code)}
                  >
                    {language.label}
                  </ButtonList.Item>
                );
              })}
            </ButtonList>
          )}
        </DropdownButtonContext.Consumer>
      }
    >
      Add language
    </DropdownButton>
  );
};
